import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssociationsApiService } from './associations.api.service';
import { TabApiService } from './tab.api.service';

@Injectable({ providedIn: 'root' })
export class AccountGroupAssociationsService {
  constructor(private associationsApiService: AssociationsApiService, private tabApiService: TabApiService) {}

  private canEnableAll(ids: string[], allIds: string[]): boolean {
    for (let i = 0; i < allIds.length; i++) {
      if (ids.indexOf(allIds[i]) === -1) {
        // They are missing access to one of the ids so we can not use enable all
        return false;
      }
    }
    return true;
  }

  public applyAccountAccess$(
    accountGroupId: string,
    userId: string,
    access: string[],
    allProductIdsOnAccount: string[],
  ): Observable<any> {
    let access$ = null;
    // There access was removed to all products, so we can use the disable all api
    if (access.length === 0) {
      access$ = this.associationsApiService.disableAllAccountAccess(accountGroupId, userId).pipe(map(() => []));
    } else if (this.canEnableAll(access, allProductIdsOnAccount)) {
      // They have access to everything so we can use the enable all products api
      access$ = this.associationsApiService.enableAllAccountAccess(accountGroupId, userId).pipe(map(() => null));
    } else {
      access$ = this.associationsApiService.setAccountAccess(accountGroupId, userId, access).pipe(map(() => access));
    }
    return access$;
  }

  public applyTabAccess$(accountGroupId: string, userId: string, tabs: string[], allTabs: string[]): Observable<any> {
    let access$ = null;
    if (tabs.length === 0) {
      access$ = this.tabApiService.disableAll(accountGroupId, userId).pipe(map(() => []));
    } else if (this.canEnableAll(tabs, allTabs)) {
      access$ = this.tabApiService.enableAll(accountGroupId, userId).pipe(map(() => null));
    } else {
      access$ = this.tabApiService.set(accountGroupId, userId, tabs).pipe(map(() => tabs));
    }

    return access$;
  }

  public deleteAssociation$(userId: string, accountGroupId: string): Observable<void> {
    return this.associationsApiService.deleteAccountGroupAssociation(userId, accountGroupId);
  }
}
